import type { UseUserPageHeaderActions } from '@openx/components-administration/lib/utils/context/UserHookTypes';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useUserDeleteModal } from './useUserDeleteModal';

export const useUserPageHeaderActions: UseUserPageHeaderActions = ({ id, name }) => {
  const { t } = useTranslation();
  const handleDeleteUser = useUserDeleteModal({ shouldRedirect: true });
  const navigate = useNavigate();

  return useMemo(
    (): ActionButtonProps[] => [
      {
        color: 'default',
        'data-test': 'edit-action-button',
        label: t('Edit'),
        onClick: () => {
          navigate(`/users/${id}/edit`);
        },
        showAsActionButton: true,
      },
      {
        color: 'error',
        'data-test': 'delete-action-button',
        label: t('Delete'),
        onClick: () => handleDeleteUser({ id, name }),
        showAsActionButton: true,
      },
    ],
    [handleDeleteUser, navigate, id, name, t]
  );
};
